import flowRight from 'lodash/flowRight'
import find from 'lodash/find'
import filter from 'lodash/filter'
import first from 'lodash/first'
import last from 'lodash/last'
import sortBy from 'lodash/sortBy'
import keys from 'lodash/keys'
import { makeSelectTotalByPctId, makeSelectBookingType, makeSelectTotalResByPctId, makeSelectQtyObj } from 'logic/orders'
import { makeSelectSeatsByIds } from 'logic/seats'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Currency } from 'components'
import { makeSelectPctById } from '../logic/pcts'
import { FormattedMessage } from 'react-intl'
import messages from '../i18n/messages'

function Prices ({ qtyObj, pct, bookingType }) {

  if (!pct) return <></>

  let minPrice = first(sortBy(filter(pct.prices, prc => !prc.bo_only), 'value'))
  let maxPrice
  if (qtyObj) {
    minPrice = first(sortBy(filter(pct.prices, prc => keys(qtyObj).includes(prc.name)), 'value'))
    if (keys(qtyObj).length > 1)
      maxPrice = last(sortBy(filter(pct.prices, prc => keys(qtyObj).includes(prc.name)), 'value'))
  }
  if (!minPrice) return <></>

  if (maxPrice)
    return  <>
              <Currency value={(bookingType === 'res') ? minPrice.res_value : minPrice.full_price} />
              <span className="mr-1 ml-1">&ndash;</span>
              <Currency value={(bookingType === 'res') ? maxPrice.res_value : maxPrice.full_price} />
            </>

  return <Currency value={(bookingType === 'res') ? minPrice.res_value : minPrice.full_price} />
}

class OfferPriceInfo extends Component {

  render() {
    const { total, pct, qtyObj, bookingType } = this.props

    if (isNaN(total)) return <></>

    return (
      <div className="small-offer">
        <div className="price-per-ticket"><FormattedMessage {...messages.pricePerTicket} /></div>
        <Prices qtyObj={qtyObj} pct={pct} bookingType={bookingType} />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  seats: makeSelectSeatsByIds(props => props.offer.seat_ids),
  bookingType: makeSelectBookingType(),
  qtyObj: makeSelectQtyObj(),
  pct: makeSelectPctById(props => props.offer.price_category_id),
  total: makeSelectTotalByPctId(props => props.offer.price_category_id),
  totalRes: makeSelectTotalResByPctId(props => props.offer.price_category_id),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(OfferPriceInfo)
